import React from "react";
import MenuAppBar from "../Header/MenuAppBar";
import UserUpdate from "./UserUpdate";

export default function User() {
  return (
    <div>
      <MenuAppBar />
      <UserUpdate />
    </div>
  );
}
